import type { TooltipItem } from '@/app/common/api/types/tooltipsApiTypes';

export function buildTooltipBySlugMap(
  tooltips: TooltipItem[],
): Record<string, TooltipItem> {
  return Object.fromEntries(
    tooltips
      .filter((item) => item.is_active !== false)
      .map((item) => [item.slug, item]),
  );
}

export function buildTooltipHtml(item: TooltipItem): string | null {
  const title = item.title?.trim();
  const description = item.description?.trim();

  if (!title && !description) {
    return null;
  }

  const parts: string[] = [];

  if (title) {
    parts.push(`<strong>${title}</strong>`);
  }

  if (description) {
    parts.push(description);
  }

  return parts.join('<br />');
}
